

import React, { useEffect } from 'react';

const ExternalRedirect = (props: { to: string, localhostOverride?: string }) => {
  useEffect(() => {
    if(window.location.hostname == "localhost" && props.localhostOverride){
        window.location.href = props.localhostOverride;
    } else {
        window.location.href = props.to;
    }    
  }, []);

  return <></>;
};

export default ExternalRedirect;
